import { List, Toast } from "antd-mobile";
import axios from "axios";
import { Modal } from "react-bootstrap";

import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PsContext from "../../context";
import {
  COURSE_TYPE_SORT_ORDER,
  customSorting,
  jsonToQuery,
  upperCase,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import { Button, Card, Col, Row } from "react-bootstrap";
import {  SpinLoading, Form } from "antd-mobile";
import AttendanceStudentList from "./attendancesStudentList";
import {lowerCase, momentDate } from "../../utils";

const AttendanceList = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [courseTypes, setCourseTypes] = useState([]);
  const [markedAttendance,setMarkedAttendance] = useState([]); 
  const params = useParams();
  const [selectedattDate, setSelectedattDate] = useState(''); 
  const [viewData, setViewData] = useState([]);
  const [showAttData,setShowAttData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedAttendance, setSelectedAttendance] = useState(null); // State for selected attendance

  const getTitle = () => {
    return params?.type
      ? `${upperCase(params.type)} Attendance  Report`
      : "Attendance  Report";
  };




  const bakcLinkClick = () => {
    let path = params?.type ? "/staff/app/my-att-report" : "/staff/app";
    navigate(path);
  };
  const loadMarkedHostelAttendance = () => {
    setLoader(true);

    const form = new FormData();
  
    form.append("staff_id", context.user.id);
    form.append("date",selectedattDate);
    axios.post(ServiceUrl.MOB.LIST_SERVICE_MARKED_ATTENDANCE, form).then((res) => {
      if (res["data"].status == "1") {
        context.setLoader(false);
        setMarkedAttendance(res["data"].data);
       // console.log('ll',res["data"].data);
    
      }
    });
    setLoader(false);

  };

  const handleDateChange = (e) => {
    setSelectedattDate(e.target.value);
  };

  const handleCardClick = (attendance) => {
    setSelectedAttendance(attendance);

    setShowAttData(true);
  };

  return (
    <>
      <Header
        onBack={(e) => bakcLinkClick()}
        title={getTitle()}
        backAction={true}
        rightActions={[]}
      />


<Card style={{ maxWidth: '650px', margin: '0 auto' }}>
            <Card.Body>
        <Row className="mt-2">
            <Col md={1}></Col>
        <Col md={8}>
          <Form
            name="attendanceForm"
            id="attendance"
            //onFinish={(e) => onfinish(e)}

          >
        
            <Form.Item name="date" label="Attendance Date">
                <input
                  className="form-control form-control-sm fw-bold"
                  type="date"
                  size="sm"
                  max={momentDate(new Date(), "YYYY-MM-DD")}

                  onChange={handleDateChange}              
             defaultValue={selectedattDate}
                />
              </Form.Item>
            <Button
              type="submit"
              variant="danger"
              size="sm"
              className="w-100 mt-3"
             onClick={loadMarkedHostelAttendance} 
            >
              Search
            </Button>
          </Form>
          </Col>
          </Row>
        </Card.Body>
      </Card>


      <div className="container py-3">
        {markedAttendance.length > 0 ? (
          <div>
            {markedAttendance.map((attendance) => (
              <Card
                key={attendance.srv_org_id}
                className="fw-bold uppercase"
                style={{ cursor: 'pointer' }}
              >
                <Card.Body>
                <Row>
    <Col xs={3}>
      <span style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>{attendance.date}</span>
    </Col>
    <Col md={1}>
      <span style={{ fontWeight: 'bold', fontSize: '1.2rem' }}> </span>
    </Col>
    <Col md={4}>
      <span style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>{attendance.srv_org_name}</span>
    </Col>
    <Col md={3} className="text-end">
              
<Button
                  size="sm"
                  variant="secondary" // Correct variant spelling
                  title="List"
                  onClick={() => handleCardClick(attendance)}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </Button>

              </Col>
  </Row>
  <Row>
  <div className="col-10 text-end">
                <Button size="sm" variant="light" style={{ fontSize: "12px" }}>
                  <span className="border-bottom text-danger">AB</span> :
                  <span className="text-danger">{attendance.count_A}</span>
                </Button>
                <Button size="sm" variant="light" style={{ fontSize: "12px" }}>
                  <span className="border-bottom text-dark">L</span>:
                  <span className="text-dark">{attendance.count_L}</span>
                </Button>
                <Button size="sm" variant="light" style={{ fontSize: "12px" }}>
                  <span className="border-bottom text-success">P</span>:
                  <span className="text-success">{attendance.count_P}</span>
                </Button>
              </div>
  </Row>
                </Card.Body>
              </Card>
            ))}
          </div>
        ) : (
          <p></p>
        )}
      </div>

  <Modal
        show={showAttData}
        onHide={() => {
          setShowAttData(false);
          setSelectedAttendance(null); 
        }}
        fullscreen
      >
        <Modal.Header className="fw-bold" closeButton>
          Attendance List
        </Modal.Header>
        <Modal.Body>
          {selectedAttendance && (
            <AttendanceStudentList
              dataSource={selectedAttendance} 
            />
          )}
        </Modal.Body>
      </Modal>
     
    </>
  );
};
export default AttendanceList;
